/**
 * @file   : AInputCurrency.js
 * @author :  ()
 * @date   : 6/5/2019, 4:16:28 PM
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { isUndefined } from '../../utilities/GeneralUtils'
import AInput from './AInput'

class AInputCurrency extends Component {
  constructor(props) {
    super(props)
    this.state = { value: props.value }
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props

    if (value !== prevProps.value && !isUndefined(value)) {
      this.setState({
        value,
      })
    }
  }

  handleChange(inputvalue) {
    this.setState({
      ...this.state,
      value: inputvalue,
    })
  }

  handleBlur(inputvalue) {
    const { onChange } = this.props
    onChange(inputvalue)
  }

  render() {
    const {
      id,
      label,
      cmpRef,
      placeholder,
      currencyNameSymbol,
      style,
      help,
      minNumber,
      maxNumber,
    } = this.props
    const { value } = this.state

    return (
      <AInput
        id={id}
        label={label}
        cmpRef={cmpRef}
        prepender={currencyNameSymbol}
        onChange={(evt) => {
          this.handleChange(evt.target.value)
        }}
        onBlur={(evt) => {
          this.handleBlur(evt.target.value)
        }}
        type={'number'}
        value={value}
        placeholder={placeholder}
        maxLength={10}
        style={style}
        help={help}
        step={'.01'}
        minNumber={minNumber}
        maxNumber={maxNumber}
      />
    )
  }

  static defaultProps = {
    placeholder: '',
    currencyNameSymbol: null,
    minNumber: null,
    maxNumber: null,
  }

  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    cmpRef: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    currencyNameSymbol: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    style: PropTypes.string,
    help: PropTypes.string,
    minNumber: PropTypes.number,
    maxNumber: PropTypes.number,
  }
}

export default AInputCurrency
